//panorama types

/*                                                                                                                                                 
PPPPPPPPPPPPPPPPP                                                                                                                                   
P::::::::::::::::P                                                                                                                                  
P::::::PPPPPP:::::P                                                                                                                                 
PP:::::P     P:::::P                                                                                                                                
  P::::P     P:::::Paaaaaaaaaaaaa  nnnn  nnnnnnnn       ooooooooooo   rrrrr   rrrrrrrrr   aaaaaaaaaaaaa      mmmmmmm    mmmmmmm     aaaaaaaaaaaaa   
  P::::P     P:::::Pa::::::::::::a n:::nn::::::::nn   oo:::::::::::oo r::::rrr:::::::::r  a::::::::::::a   mm:::::::m  m:::::::mm   a::::::::::::a  
  P::::PPPPPP:::::P aaaaaaaaa:::::an::::::::::::::nn o:::::::::::::::or:::::::::::::::::r aaaaaaaaa:::::a m::::::::::mm::::::::::m  aaaaaaaaa:::::a 
  P:::::::::::::PP           a::::ann:::::::::::::::no:::::ooooo:::::orr::::::rrrrr::::::r         a::::a m::::::::::::::::::::::m           a::::a 
  P::::PPPPPPPPP      aaaaaaa:::::a  n:::::nnnn:::::no::::o     o::::o r:::::r     r:::::r  aaaaaaa:::::a m:::::mmm::::::mmm:::::m    aaaaaaa:::::a 
  P::::P            aa::::::::::::a  n::::n    n::::no::::o     o::::o r:::::r     rrrrrrraa::::::::::::a m::::m   m::::m   m::::m  aa::::::::::::a 
  P::::P           a::::aaaa::::::a  n::::n    n::::no::::o     o::::o r:::::r           a::::aaaa::::::a m::::m   m::::m   m::::m a::::aaaa::::::a 
  P::::P          a::::a    a:::::a  n::::n    n::::no::::o     o::::o r:::::r          a::::a    a:::::a m::::m   m::::m   m::::ma::::a    a:::::a 
PP::::::PP        a::::a    a:::::a  n::::n    n::::no:::::ooooo:::::o r:::::r          a::::a    a:::::a m::::m   m::::m   m::::ma::::a    a:::::a 
P::::::::P        a:::::aaaa::::::a  n::::n    n::::no:::::::::::::::o r:::::r          a:::::aaaa::::::a m::::m   m::::m   m::::ma:::::aaaa::::::a 
P::::::::P         a::::::::::aa:::a n::::n    n::::n oo:::::::::::oo  r:::::r           a::::::::::aa:::am::::m   m::::m   m::::m a::::::::::aa:::a
PPPPPPPPPP          aaaaaaaaaa  aaaa nnnnnn    nnnnnn   ooooooooooo    rrrrrrr            aaaaaaaaaa  aaaammmmmm   mmmmmm   mmmmmm  aaaaaaaaaa  aaaa
*/
//baseclass

const Camera = require('./Camera.js').default
const CanvasManager = require('./CanvasManager.js').default
import { fireEvent } from './PanoPlayer'

var delta,
    noop = function() {}

export default function Panorama(player) {
    this.player = player

    this.rootType = null

    this.meshes = []
    this._ondrag = []
    this._onDestroyCBs = []
    this.regenerateTextures = noop

    // Panorama.prototype = {
    this.setAutoRotate = function(onOff, autoRotateSpeed) {
        this.camera.setAutoRotate(onOff, autoRotateSpeed)
    }

    this.embed = function() {
        var _this = this

        this.scene = new THREE.Scene()
        this.scene.frustumCulled = false
        this.camera = new Camera(this.player.getCameraOptions(), this)

        this.createIntersectionMesh()

        this.addMeshesToScene()

        this.attachHandlers()

        this.needsRefresh = true
        this.needsConstantRefresh = false

        //start animation loop
        this.animate()
    }

    this.createIntersectionMesh = function() {
        this.intersectionMesh = new THREE.Mesh(
            new THREE.SphereGeometry(this.player.viewerWidth * 2), //check for legacy probs
            new THREE.MeshBasicMaterial({
                side: THREE.BackSide,
            })
        )
    }

    this.addMeshesToScene = function() {
        for (var i in this.meshes) {
            this.scene.add(this.meshes[i])
        }
    }

    this.animate = () => {
        this.lastAnimationRequest = requestAnimationFrame(this.animate)

        if (this.camera.needsRefresh()) {
            this.camera.refreshView()
            this.needsRefresh = true
        }
        if (this.needsRefresh || this.needsConstantRefresh) {
            this.renderer.autoClear = false
            if (this.renderer.clear) this.renderer.clear()
            this.renderer.render(this.scene, this.camera.getCamera())
            this.scene.draw(delta)
            this.needsRefresh = false
        }
    }
    /**
     * This function should be turned off as often as on
     * It will cause high CPU usage on devices but result in max frame rate
     */
    this.setConstantRefresh = function(enabled) {
        this.needsConstantRefresh = enabled
    }

    this.setNeedsRefresh = function() {
        this.needsRefresh = true
    }

    this.onDestroy = function(callback) {
        if (callback) {
            this._onDestroyCBs.push(callback)
        }
    }

    this.destroy = function() {
        for (var i = 0; i < this._onDestroyCBs.length; i++) {
            if (this._onDestroyCBs[i]) this._onDestroyCBs[i]()
        }

        if (this.lastAnimationRequest) {
            var cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame
            cancelAnimationFrame(this.lastAnimationRequest)
        }

        this.removeHandlers()
        this._onDestroyCBs = null
        if (this.element) {
            CanvasManager.releaseCanvas(this.element)
            this.element = null
        }

        this.camera.destroy()

        delete this.scene
        delete this.camera
    }

    this.setSize = function(width, height) {
        this.renderer.setSize(width, height)

        this.needsRefresh = true

        if (this.camera) {
            this.camera.updateMatrix(width, height)
        }
    }

    this.getTileUrl = function(coord, zoom, classInstance) {
        var size = zoom !== undefined ? this.player.zoomLevels[zoom] : this.player.getPanoWidth()
        // var size = zoom !== undefined ? this.player.zoomLevels[4] : this.player.getPanoWidth()

        return classInstance._getTileUrl(this.player.basePath + this.player.panoId + '/', size, coord)
    }

    /**
     * Adds a listener function for drag events
     * Also removes drag hint if applicable
     * @param  callback {Function} - function to listen to drag events
     */
    this.onDrag = function(callback) {
        this._ondrag.push(callback)
    }

    /**
     * @param  callback {Function} - function to stop listen to drag events
     * Removes a specified listener function for drag events or removeds
     * all listeners if no callback specified
     */
    this.offDrag = function(callback) {
        if (callback) {
            for (var i = 0; i < this._ondrag.length; i++) {
                if (this._ondrag[i] === callback) {
                    this._ondrag.splice(i, 1)
                    i--
                }
            }
        } else {
            this._ondrag = []
        }
    }

    /**
     * triggers all registered drag events
     */
    this.triggerDrag = function() {
        for (var i = 0; i < this._ondrag.length; i++) {
            this._ondrag[i]()
        }
    }
    ;(this.events = {
        mousedown: null,
        mousemove: null,
        mouseup: document,
        wheel: null,
        mousewheel: null,
        touchstart: document,
        touchmove: document,
        touchend: document,
        mouseout: null,
        click: null,
    }),
        (this.handleEvent = function(event) {
            if (this.camera.isRotating) {
                return
            }
            if (this.isOwnElement(event.target)) {
                // PREVENT EVENTS ON OTHER TARGETS
                if (event.defaultPrevented != false) event.preventDefault()
            } else {
                // PREVENT ALL CAMERA EVENTS IF NOT THE TARGET
                return
            }

            if (event.type.indexOf('touch') != -1 && event.touches.length) {
                event.clientX = event.touches[0].clientX
                event.clientY = event.touches[0].clientY
            }

            // this.player.eventEmitter.trigger(event.type, [event])
            fireEvent(event.type, [event])

            switch (event.type) {
                case 'mouseout':
                    this.camera.setMouseMoving(false)
                    this.scene.call('mouseout', [])
                    break
                case 'mousedown':
                case 'touchstart':
                    this.setAutoRotate(false)
                    if (!this.camera.isDisabled()) {
                        this.camera.setMouseMoving(true)
                        this.camera.setStart(event.clientX, event.clientY)
                    }
                    this.scene.call('mousedown', [])
                    // this.player.eventEmitter.trigger('dragstart', [event])
                    fireEvent('dragstart', [event])
                    break

                case 'touchmove':
                case 'mousemove':
                    if (event.defaultPrevented != false) event.preventDefault()

                    this.isDragging = this.camera.isMoving || this.camera.isMouseMoving
                    if (this.camera.isMouseMoving) {
                        this.triggerDrag()
                        this.camera.setPosition(event.clientX, event.clientY)
                    }
                    if (!this.mouse) {
                        this.mouse = new THREE.Vector2()
                    }
                    var offset = $(event.target).offset(),
                        x = event.pageX - offset.left,
                        y = event.pageY - offset.top
                    this.mouse.x = (x / this.player.viewerWidth) * 2 - 1
                    this.mouse.y = -(y / this.player.viewerHeight) * 2 + 1
                    this.scene.call('mousemove', [])
                    break

                case 'mouseup':
                case 'touchend':
                    this.camera.setMouseMoving(false)
                    if (this.isDragging) {
                        // this.player.eventEmitter.trigger('dragend', [event])
                        fireEvent('dragend', [event])
                    } else {
                        //this even will allow us to have similar to click for mobile.
                        //if ! dragging and we are ending then. call touch
                        this.scene.call('touch', [])
                    }
                    this.scene.call('mouseup', [])
                    this.isDragging = false
                    break

                case 'wheel':
                case 'mousewheel':
                    this.camera.zoom(event.wheelDelta > 0 || event.detail < 0 || event.deltaY < 0 ? 1 : -1)
                    break
                case 'click':
                    this.isDragging = false
                    break
            }
        })

    this.isOwnElement = function(element) {
        return element == this.element
    }

    //event handlers
    this.attachHandlers = function() {
        for (var i in this.events) {
            var scope = this.events[i] || this.element
            scope.addEventListener(i, this, false)
        }
    }

    this.removeHandlers = function() {
        for (var i in this.events) {
            var scope = this.events[i] || this.element
            scope.removeEventListener(i, this, false)
        }
    }
}
